import angular from 'angular';

import {Service, Module} from './../decorators';
import R from './../resource';

@Module({
    name: 'app.services.user',
    modules: [R],
})
@Service('UserService')
export default class UserService {
    constructor ($q, R) {
        'ngInject';
        this.R = R;
        this.endpoint = R.one('users', 'me');
        this.deferred = $q.defer();
        this.promise = this.deferred.promise;
        this.reset();
    }

    reset () {
        this.$user = {};
    }

    refresh () {
        let self = this;
        let request = window.ReactBridge && window.ReactBridge.getCurrentUser
            ? window.ReactBridge.getCurrentUser()
                .then(response => self.R.restangularizeElement(null, response, 'users', true))
            : self.endpoint.get();
        request.then(function (response) {
            angular.extend(self.$user, response);
            self.deferred.resolve(self);
        });
        return self.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/user.js